module.exports = __webpack_public_path__ + "img/fox.f442efec.gif";